import React, {ReactNode} from 'react'

import {Avatar, AvatarType} from '@vio/atlas/Avatar'
import {getUserName} from '@vio/core/src/auth/business/authentication'
import {User} from '@vio/core/src/auth/types/Cognito'

interface Props {
  className?: string
  user: User | null
  /** Custom icon to show instead of the default avatar when there is no picture */
  icon?: ReactNode
}

export const UserAvatar = ({className, user, icon}: Props) => {
  const picture = user?.attributes?.picture

  if (!picture && icon) {
    return <>{icon}</>
  }

  return (
    <Avatar
      className={className}
      picture={picture}
      type={picture ? AvatarType.Picture : AvatarType.Icon}
      name={getUserName(user || null)}
    />
  )
}
